import { render, staticRenderFns } from "./TypesTab.vue?vue&type=template&id=1b9aa718&scoped=true"
import script from "./TypesTab.vue?vue&type=script&lang=js"
export * from "./TypesTab.vue?vue&type=script&lang=js"
import style0 from "./TypesTab.vue?vue&type=style&index=0&id=1b9aa718&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9aa718",
  null
  
)

export default component.exports